import React from "react";
import Body from "./Body.js";
import './App.css';

function App () {
    return(
        <>
        <Body/>
        </>
    )
}

export default App;
